import { Component, Inject, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AddressIndicatorLogDto } from '@shared/src/controllers/address/indicator/AddressIndicatorLogDto';
import { HomeController, SharedAsideFactory, SharedSaveButtonEvent } from '@shared/src/public-api';
import { RoutePropertyDto } from '@shared/src/controllers/route/properties/RoutePropertyDto';
import { ValueControlCtrl } from '@shared/src/dtos/core/valuecontrol/ValueControlCtrl';
import { RoutePropertyLogDto } from '@shared/src/controllers/route/properties/RoutePropertyLogDto';
import { RoutePropertyController } from '@shared/src/controllers/route/properties/route.property.controller';
import { OpenRoutePropertyController } from '@shared/src/controllers/open/open.route.property.controller';
import { RoutePropertyChanged } from '@shared/src/controllers/route/properties/RoutePropertyChanged';


@Component({
  selector: 'shared-route-property',
  templateUrl: './shared.route.property.component.html',
  styleUrls: ['./shared.route.property.component.scss']
})
export class SharedRoutePropertyComponent implements OnInit {

  rForm: FormGroup;

  @Input() public readonly: boolean = false;

  public logs: Array<RoutePropertyLogDto>;

  constructor(private fb: FormBuilder,
    @Inject('HomeController') public homeController: HomeController,
    public routePropertyController: RoutePropertyController, public openRoutePropertyController: OpenRoutePropertyController, @Inject('SharedAsideFactory') public sharedAsideFactory: SharedAsideFactory) {

    this.rForm = this.fb.group({
      'valueControl': ['', Validators.nullValidator]
    });

  }
  @Input()
  public pendingresponse: boolean = false;

  @Input()
  public driver: boolean = false;

  @Input()
  public exwork: boolean = false;

  @Input()
  public uuid: string;
  
  @Input()
  public routeId: number;


  ngOnInit(): void {
    this.loadValueControl();
  }

  private _value: RoutePropertyDto = null;
  @Input() public set value(value: RoutePropertyDto) {
    if (this._value === value)
      return;
    this._value = value;
    this.loadValueControl();
  }
  public get value(): RoutePropertyDto {
    return this._value;
  }

  private _edit: boolean = null;
  @Input() public set edit(value: boolean) {
    if (this._edit === value)
      return;
    this._edit = value;
    if (this._edit)
      this.history = false;
  }
  public get edit(): boolean {
    return this._edit;
  }

  private _history: boolean = null;
  @Input() public set history(value: boolean) {
    if (this._history === value)
      return;
    this._history = value;
    if (this._history) {
      this.edit = false;
    }
  }
  public get history(): boolean {
    return this._history;
  }

  public save($event: SharedSaveButtonEvent) {
    this.value.value = this.valueControl.getValueString();
    if (this.exwork) {
      if (!this.driver) {
        this.openRoutePropertyController.setExworkValue(this.uuid, this.value).subscribe(data => {
          this.welcomeSetValue(data, $event);
        });
      } else {
        this.openRoutePropertyController.setDriverValue(this.uuid, this.value).subscribe(data => {
          this.welcomeSetValue(data, $event);
        });
      }
    } else {
      this.routePropertyController.setValue(this.value).subscribe(data => {
        this.welcomeSetValue(data, $event);
      });
    }
  }

  welcomeSetValue(data: RoutePropertyChanged, $event: SharedSaveButtonEvent) {
    if (data && data.result) {

      if (this.value != null)
        this.homeController.onRoutePropertiesChanged$.next(RoutePropertyChanged.setRouteId(data, this.routeId > 0 ? this.routeId : this.value.routeId));

      this.rForm.markAsPristine();
      this.edit = false;
    }
    if ($event)
      $event.callback();

    this.back();
  }

  @Output() public updateList: EventEmitter<RoutePropertyDto> = new EventEmitter<RoutePropertyDto>();
  onValueChanged(event) {
    if (this.value == null)
      return;

    this.value.value = this.valueControl.getValueString();
    this.updateList.next(this.value);

  }

  public back() {
    this.rForm.markAsPristine();
    this.edit = false;
    this.history = false;
  }

  onClickUser(item: AddressIndicatorLogDto) {
    if (item != null && item.userId != null) {
      this.sharedAsideFactory.invokeUserLogInfo(item.userId).then(value => { });
    }
  }

  public valueControl: ValueControlCtrl;
  public loadValueControl() {
    this.valueControl = ValueControlCtrl.buildAndLoadValue(this.value.routePropertyDefinition.routePropertyDefinitionKey, this.value.dataType, null, null, "", "", false, this.value.value);
  }

  pretty(data) {
    return JSON.stringify(data);
  }
}
